import PublicLayout from '../PublicLayout';

const CloneLayout = () => (
  <PublicLayout surface="cinematic" footerVariant="full" showFooterCta />
);

export default CloneLayout;
